"use client"

import Script from "next/script"

// Preproduction defaults so a checkout without the NEXT_PUBLIC_GHC_* block in
// .env still boots. Production overrides these per stage in sst.config.ts.
const SCRIPT_URL =
  process.env.NEXT_PUBLIC_GHC_SCRIPT_URL ||
  "https://gaminghub-web.preproduction.dreamteam.wlg.engagecraft.com/webcomponent/index.js"
// Must match the server's GH_API_NAME. The web component mints the token under
// this game registration, and the Gaming Hub rejects it at game/users if the
// backend then asks under a different one.
const GAME = process.env.NEXT_PUBLIC_GHC_GAME || "epllastmanstanding"
const COMPETITION_ID = process.env.NEXT_PUBLIC_GHC_COMPETITION_ID || "8"
const SEASON = process.env.NEXT_PUBLIC_GHC_SEASON || "current"
const LANGUAGE = process.env.NEXT_PUBLIC_GHC_LANGUAGE || "en"

/**
 * Mounts the Gaming Hub web component. It runs in hidden mode: we only use it
 * as an auth broker, so it must not paint any UI of its own.
 *
 * The element is rendered before the script loads on purpose. `customElements`
 * upgrades it once `customElements.define("g-h-c", ...)` runs, and by then
 * React has already applied the attributes, so `connectedCallback` sees them.
 */
export function GamingHubComponent() {
  return (
    <>
      <g-h-c
        language={LANGUAGE}
        game={GAME}
        hiddenMode="true"
        competitionId={COMPETITION_ID}
        season={SEASON}
      />
      <Script src={SCRIPT_URL} strategy="afterInteractive" />
    </>
  )
}
